<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :active="item.selected" @click="item.selected = !item.selected" class="list-clickable">
                <td>{{ item.ID }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.FullName}}</td>
                <td>{{ item.PhoneNumber }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, customer_status)}">{{ item.Status | display_value(customer_status) }}</td>
                <!-- <td class="text-right">{{ item.Wallet | currency }}</td>
                <td class="text-right" v-if="roleAdmin">
                    <v-edit-dialog :return-value.sync="item.KuaidiWeightPrice" eager lazy @save="saveItem({'ID': item.ID, 'KuaidiWeightPrice': item.KuaidiWeightPrice})">
                        <div>{{ item.KuaidiWeightPrice | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.KuaidiWeightPrice" type="number" step="1" label="Phí cân kuaidi" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.KuaidiWeightPrice | currency }}</td>
                <td class="text-right" v-if="roleAdmin">
                    <v-edit-dialog :return-value.sync="item.ShipmentWeightPrice" eager lazy @save="saveItem({'ID': item.ID, 'ShipmentWeightPrice': item.ShipmentWeightPrice})">
                        <div>{{ item.ShipmentWeightPrice | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.ShipmentWeightPrice" type="number" step="1" label="Phí cân lô" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.ShipmentWeightPrice | currency }}</td>
                <td class="text-right" v-if="roleAdmin">
                    <v-edit-dialog :return-value.sync="item.ShipmentVolumePrice" eager lazy @save="saveItem({'ID': item.ID, 'ShipmentVolumePrice': item.ShipmentVolumePrice})">
                        <div>{{ item.ShipmentVolumePrice | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.ShipmentVolumePrice" type="number" step="1" label="Phí khối lô" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.ShipmentVolumePrice | currency }}</td> -->
                <td v-if="roleAdmin">
                  <v-edit-dialog :return-value.sync="item.SaleID" eager lazy @save="saveItem({'ID': item.ID, 'SaleID': item.SaleID})">
                        <div>{{ getStaffName(item.SaleID) }}</div>
                        <template v-slot:input>
                          <v-select v-model="item.SaleID" :items="sales" item-value="ID" item-text="FullName" label="Nhân viên sale" single-line autofocus></v-select>
                        </template>
                    </v-edit-dialog>
                </td>
                <td v-else>{{ getStaffName(item.SaleID) }}</td>
                <td class="text-center">
                  <a 
                  target="_blank" 
                  :href="'/khach-hang/' + item.ID"
                  ><i role="button" medium="" class="v-icon notranslate mr-2 v-icon--link material-icons theme--light">{{roleEditable ? 'edit' : 'visibility'}}</i></a>
                  <v-icon medium class="mr-2" @click="copyAddress(item.Username)">fa-copy</v-icon>
                  
                  <v-tooltip top >
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="updatePrice(item.ID)">fa-refresh</v-icon>
                      </template>
                      <span>Cập nhật giá</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <span>
                <p class="pt-2">Không có dữ liệu</p>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import createPermissionMixin from "@/mixins/permissionMixin";
import _, { update } from "lodash";

export default {
  mixins: [createPermissionMixin('customer')],
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      search: "",
      customer_status: configs.CUSTOMER_STATUS_LIST,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "customer_list",
      filterConditions: [],
      quickFilterConditions: []
    };
  },
  computed: {
    ...mapState({
      items: state => state.customer.all.data,
      total_rows: state => state.customer.all.total,
      loading: state => state.customer.loading,
      selected: state => state.customer.selected,
      sales: state => state.staff.all.data,
      configuration: state => state.configuration.selected
    }),
    roleAdmin() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    },
    accountantRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Manager || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Sale || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.StoreBatch;
    },
    headers() {
      return [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mã khách hàng",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tên",
          value: "FullName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Điện thoại",
          value: "PhoneNumber",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.CUSTOMER_STATUS_LIST
        },
        // {
        //   text: "Dư ví",
        //   value: "Wallet",
        //   filterable: true,
        //   align: 'end',
        //   decimal: 0,
        //   dataType: configs.DATA_TYPE["Number"]
        // },
        // {
        //   text: "Phí cân kuaidi",
        //   value: "KuaidiWeightPrice",
        //   align: 'end',
        //   filterable: true,
        //   decimal: 0,
        //   dataType: configs.DATA_TYPE["Number"]
        // },
        // {
        //   text: "Phí cân lô",
        //   value: "ShipmentWeightPrice",
        //   align: 'end',
        //   filterable: true,
        //   decimal: 0,
        //   dataType: configs.DATA_TYPE["Number"]
        // },
        // {
        //   text: "Phí khối lô",
        //   value: "ShipmentVolumePrice",
        //   align: 'end',
        //   filterable: true,
        //   decimal: 0,
        //   dataType: configs.DATA_TYPE["Number"]
        // },
        {
          text: "Nhân viên sale",
          value: "SaleID",
          filterable: true,
          values: _.map(this.sales, (item) => {
              return {
                  value: item.ID,
                  name: item.FullName,
              };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ];
    }
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    accountantRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.accountantRole || !this.hasEditPermission});
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("customer/getCustomerList", param);
      this.$store.dispatch("staff/getList", {filter:[{column: "RoleID", value: configs.ROLE_TYPE.Sale, condition: "equal"}]});
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "CustomerDetail",
        params: {
          Pid: id,
          title: `Khách hàng (#${id})`
        }
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      if(this.roleEditable) {
        this.selected = {
            ID: 0,
            RoleID: 0,
            Status: 1,
            is_active: 1,
            is_admin: 0
        };
        this.$router.push({
          name: "CustomerDetail",
          params: {
            Pid: 'tao-moi',
            title: `Tạo mới khách hàng`
          }
        });
      }
      else {
        sendErrorNotice("Bạn không có quyền tạo mới khách hàng!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("customer/setCustomerDetail", {
        'data': item,
        'id': item.ID
      });
    },
    updatePrice(customerId) {
      this.$store.dispatch("customer/setCustomerDetail", {
        data: {
          Action: 'updatePrice'
        },
        id: customerId
      });     
    },
    getStaffName(id) {
      const staff = _.find(this.sales, { ID: id });
      return staff ? staff.FullName : "";
    },
    copyAddress(username) {
      let addr = this.configuration.ChinaStoreAddress.replace('MKH', username);
      navigator.clipboard.writeText(addr).then(() => {
        sendSuccessNotice("Đã copy địa chỉ kho:" + addr);
      }).catch(err => {
        sendErrorNotice("Lỗi copy địa chỉ kho!");
      });
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeMount() {
    this.$store.commit("customer/setCustomerList", {data: []})
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
<style scoped>
a {
    text-decoration: none !important;
}
</style>